"use client";

import { spring, useCurrentFrame, useVideoConfig } from "remotion";

export default function PhotoStack() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const photos = [
    { label: "Photo 1", rotation: -5, gradient: "linear-gradient(135deg, #1d4ed8, #3b82f6)", delay: 0 },
    { label: "Photo 2", rotation: 0, gradient: "linear-gradient(135deg, #7c3aed, #a855f7)", delay: 8 },
    { label: "Photo 3", rotation: 5, gradient: "linear-gradient(135deg, #059669, #34d399)", delay: 16 },
  ];

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: "#111827",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {photos.map((photo, i) => {
        const appear = spring({
          frame: frame - photo.delay,
          fps,
          config: { damping: 12, stiffness: 100 },
        });

        const scale = appear;
        const opacity = appear;
        const offsetX = (i - 1) * 30;
        const offsetY = (i - 1) * -10;

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              width: "200px",
              height: "260px",
              transform: `translate(${offsetX}px, ${offsetY}px) rotate(${photo.rotation}deg) scale(${scale})`,
              opacity,
              borderRadius: "8px",
              border: "6px solid white",
              boxShadow: "0 8px 30px rgba(0, 0, 0, 0.4)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              background: photo.gradient,
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                marginBottom: "0.75rem",
              }}
            />
            <span
              style={{
                color: "white",
                fontSize: "1.2rem",
                fontWeight: "bold",
              }}
            >
              {photo.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
